import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { MyDispatch, MySelector } from "../../redux/store"
import { Box, Modal } from "@mui/material"
import { setMoveFolderArray } from "../../redux/utilSlice"
import { returnStyle, title } from "../../utils/popupModalStyle"
import { HandleAsyncFns } from "../../hooks/handleAsyncFns"
import folderIcon from "../../assets/download_folder.svg"

const MoveFolderModal = () => {
  const dispatch = useDispatch<MyDispatch>()

  const { moveFolderArray } = MySelector((state) => state.util)
  const { theme } = MySelector((state) => state.theme)
  const { eventFolders, allFiles } = MySelector((state) => state.gallery)

  const { moveFile } = HandleAsyncFns()

  const [showModal, setShowModal] = useState(false)

  const countFilesOfFolder = (folderId: string) => {
    const filesInFolder = allFiles?.filter(
      (f: { folderId: string }) => f.folderId === folderId
    )

    if (filesInFolder && Array(filesInFolder).length > 0)
      return filesInFolder?.length

    return 0
  }

  // to toggle the modal
  useEffect(() => {
    if (!moveFolderArray) setShowModal(false)
    else setShowModal(true)
  }, [moveFolderArray])

  return (
    <Modal
      open={showModal}
      onClose={() => {
        setShowModal(false)
        dispatch(setMoveFolderArray(null))
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={returnStyle(theme)}>
        <div className="py-5 px-3 md:px-[20px] md:py-[30px] max-h-[80vh] overflow-y-auto">
          <p className={title}>Move To Folder</p>
          <div className="mt-6 space-y-4 md:space-y-6">
            {eventFolders?.map((ef: { id: string; name: string }) => (
              <div
                key={ef?.id}
                onClick={() => moveFile(ef?.id, moveFolderArray || [])}
                className="flex items-center gap-3 cursor-pointer px-2 py-1 rounded-md hover:bg-offWhite dark:hover:bg-blackish transition-all duration-200 ease-linear"
              >
                <img src={folderIcon} alt="" className="h-8 w-8 md:h-10 md:w-10" />
                <div className="flex flex-col gap-1.5">
                  <p className="dark:text-[#FEFEFE] font-medium text-sm md:text-base leading-[100%] md:leading-[100%]">
                    {ef?.name}
                  </p>
                  <p className="text-offGrey font-medium text-xs md:text-[13px] leading-[100%] md:leading-[100%]">
                    {countFilesOfFolder(ef?.id)}{" "}
                    {countFilesOfFolder(ef?.id) > 1 ? "Files" : "File"}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default MoveFolderModal
